<template>
  <StickyTable class="target-table" v-if="!!type || busy" :loading="busy">
    <template #header>
      <tr>
        <Cell th>目標</Cell>
        <Cell th>人数</Cell>
      </tr>
    </template>
    <template #body>
      <template v-if="busy">
        <tr>
          <Cell colspan="2" class="loading" />
        </tr>
      </template>
      <template v-else-if="type === 1">
        <tr>
          <Cell class="target">月間</Cell>
          <Cell class="numbers">{{ numberFormat(target.monthly) }}<span>人</span></Cell>
        </tr>
        <tr>
          <Cell class="target"> 1日あたり<span>※当月の営業日を基に算出</span> </Cell>
          <Cell class="numbers">{{ target.split }}<span>人</span></Cell>
        </tr>
      </template>
      <template v-else-if="type === 2">
        <tr v-for="(week, key) in weeks" :key="key">
          <Cell class="target">{{ week }}曜日</Cell>
          <Cell class="numbers">{{ target.weekly[key] }}<span>人</span></Cell>
        </tr>
        <tr>
          <Cell class="target"> 月間<span>※当月の営業日を基に算出</span> </Cell>
          <Cell class="numbers">{{ numberFormat(target.sum) }}<span>人</span></Cell>
        </tr>
      </template>
      <template v-else>
        <tr>
          <Cell colspan="2" class="not-set">
            目標が未設定です
          </Cell>
        </tr>
      </template>
    </template>
  </StickyTable>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { numberFormat } from '@/utils/number'
import StickyTable, { Cell } from '@/components/molecules/StickyTable'

export default {
  name: 'TargetTable',
  components: {
    StickyTable,
    Cell,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      busy: state => state.analysis.target.busy,
      type: state => state.analysis.target.type,
      target: state => state.analysis.target.target,
    }),
    ...mapGetters({
      weeks: 'analysis/target/weeks',
    }),
  },
  methods: {
    numberFormat,
  },
}
</script>

<style scoped lang="postcss">
.target-table {
  th {
    /** TODO 共通化 */
    height: 32px;

    &:last-child {
      width: 176px;
    }
  }

  td {
    font-size: 15px;
    padding: 0 16px;

    &.target {
      span {
        color: var(--dark-gray);
        font-size: 10px;
        margin-left: 10px;
      }
    }

    &.numbers {
      font-size: 21px;
      text-align: right;

      span {
        font-size: 15px;
      }
    }
  }

  .loading {
    height: 112px;
  }

  .not-set {
    height: 112px;
    text-align: center;
  }
}
</style>
